<template>
  <v-alert
    v-bind="{ ...$attrs, ...$props }"
    variant="tonal"
    class="e-hint"
    icon="icon-warning-hint-filled"
    close-icon="icon-close-sign"
    :class="classes">
    <template v-for="(_, slot) in $slots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>
  </v-alert>
</template>

<script setup>
import { computed } from 'vue';
import { VAlert } from 'vuetify/components/VAlert';

const props = defineProps({
  variant: {
    type: String,
    default: 'default',
  },
  size: {
    type: String,
    default: '',
  },
})

const classes = computed(() => {
  return {
    [`e-hint--variant-${props.variant}`]: true,
    'e-size--small': props.size === 'small',
  }
})
</script>

<style lang="scss">
@import '../../scss/styles';
.v-alert.e-hint {
  border-radius: 6px;
  border: 1px solid transparent;
  &.e-size--small {
    padding: 8px;
  }
  .v-alert__underlay {
    display: none;
  }
  .v-alert__prepend {
    margin-inline-end: 8px;
    .v-icon {
      font-size: 24px !important;
      width: 24px !important;
      height: 24px !important;
    }
  }
  .v-alert__content {
    font-size: 14px;
  }
  .v-alert-title {
    font-size: 16px;
    font-weight: 400;
  }
  .v-alert__close {
    .v-btn {
      height: 24px;
      width: 24px;
    }
    .v-icon {
      font-size: 24px;
    }
  }
  &--variant-default {
    color: $graybase;
    background: $grayscale50;
    border-color: $grayscale100;
  }
  &--variant-danger {
    color: $danger400;
    background: $danger50;
    border-color: $danger100;
  }
  &--variant-warning {
    color: $warning400;
    background: $warning50;
    border-color: $warning100;
  }
  &--variant-info {
    color: $primary400;
    background: $primary50;
    border-color: $primary100;
  }
}
</style>
